var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConversationContextService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.87 6C19.18 6 21.06 7.88 21.06 10.19V13.56C21.06 15.87 19.18 17.75 16.87 17.75H8.11C7.24 17.75 6.56 17.55 5.85 17.1C5.68 16.99 5.49 16.94 5.31 16.94C5.06 16.94 4.81 17.03 4.62 17.22C4.48 17.31 3.88 17.57 3.15 17.6C3.8 16.84 3.91 16.05 3.94 15.31C3.94 15 3.94 14.75 3.94 14.46C3.94 14.22 3.93 13.94 3.93 13.57V10.19C3.93 7.88 5.8 6 8.11 6H16.87ZM16.87 5H8.11C5.25 5 2.93 7.32 2.93 10.19V13.56C2.93 14.37 2.95 14.73 2.94 15.28C2.9 16.08 2.83 17.03 1 17.92C1.6 18.41 2.33 18.58 3.01 18.58C4.11 18.58 5.1 18.15 5.31 17.92C6.04 18.39 6.89 18.73 8.11 18.73H16.87C19.73 18.73 22.06 16.41 22.06 13.54V10.19C22.06 7.32 19.74 5 16.87 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.81 9.5L18.64 11.51L15.81 13.51",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65002 13.51L6.83002 11.5L9.66002 9.5",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.57 8.2C12.95 10.37 12.33 12.54 11.7 14.71",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversationContextService);
export default __webpack_public_path__ + "static/media/icon-conversation-context-service.fc6ea866.svg";
export { ForwardRef as ReactComponent };